<template>
  <supplier-component/>
</template>

<script>
import SupplierComponent from '@/spa/components/board/supplier-management/BoardSupplierManagement';

export default {
  name: 'SupplierManagementPage',
  components: {
    SupplierComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/SupplierManagementPage.vue